var _desc, _linearGradient, _linearGradient2, _linearGradient3, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHourglass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 100 100",
    height: 100,
    viewBox: "0 0 100 100",
    width: 100,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Hourglass Icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "An hourglass icon symbolizing time and its passage.")), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 50.3147,
    x2: 49.9853,
    y1: 3.9122,
    y2: 52.0082
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1023,
    stopColor: "#8ac8fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#377abf"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientUnits: "userSpaceOnUse",
    x1: 50.6103,
    x2: 49.9514,
    y1: 50.7035,
    y2: 96.1698
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1023,
    stopColor: "#81a7cf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1c5896"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    gradientUnits: "userSpaceOnUse",
    x1: 50.3767,
    x2: 49.6877,
    y1: -7.8946,
    y2: 97.8531
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0193531,
    stopColor: "#97c3f1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1e5997"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m23.2 96.7h53.7c.1-1.3.1-2.6.1-4 0-19.2-13.4-33.9-19.9-41-1-1-1-2.6 0-3.7 6.6-7.1 19.9-21.8 19.9-41 0-1.3 0-2.7-.1-4h-53.7c-.1 1.3-.1 2.6-.1 4 0 19.2 13.1 33.9 19.6 41 1 1 1 2.6 0 3.7-6.6 7-19.6 21.7-19.6 41 0 1.4 0 2.7.1 4z",
    fill: "url(#a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m23.2 96.7h53.7c.1-1.3.1-2.6.1-4 0-19.2-14.9-33.9-21.4-41-1-1-10-1-11 0-6.6 7-21.4 21.7-21.4 41-.1 1.4-.1 2.7 0 4z",
    fill: "url(#b)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m78 99.9h-56c-1.3 0-2.3-1-2.4-2.3-.2-2.1-.3-4.3-.3-6.6 0-18.7 14.7-33.3 21.5-41.1-6.9-7.9-21.5-22.4-21.5-41.1 0-2.2.1-4.4.3-6.6.1-1.3 1.2-2.3 2.4-2.3h56c1.3 0 2.3 1 2.4 2.3.2 2.1.3 4.3.3 6.5 0 18.7-14.7 33.3-21.5 41.1 6.9 7.9 21.5 22.4 21.5 41.1 0 2.2-.1 4.4-.3 6.6 0 1.4-1.1 2.4-2.4 2.4zm-53.8-5h51.6c.1-1.3.1-2.5.1-3.8 0-18.5-15.5-32.6-21.8-39.4-.9-1-.9-2.5 0-3.5 6.3-6.8 21.8-20.9 21.8-39.4 0-1.3 0-2.6-.1-3.8h-51.6c-.1 1.3-.1 2.5-.1 3.8 0 18.4 15.5 32.6 21.8 39.4.9 1 .9 2.5 0 3.5-6.3 6.8-21.8 20.9-21.8 39.3 0 1.3.1 2.6.1 3.9z",
    fill: "url(#c)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHourglass);
export default __webpack_public_path__ + "static/media/hourglass.e1fa4d9b76c1a9cef6e13226ecef6d25.svg";
export { ForwardRef as ReactComponent };